// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nH2j","textarea":"styles_textarea__3RkvU"};